import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { Popover } from 'react-bootstrap';
import * as TooltipTourActions from './TooltipTourActions';

const BUILDER_TOP_PADDING = 70;
const TOOLTIP_ARROW_OFFSET = 8;
const withToolboxTourTooltip = (WrappedComponent) => {
  class WrappedComponentWithToolboxTourTooltip extends React.PureComponent {
    render() {
      const {
        activeToolboxTip,
        isToolboxTipHidden,
        tooltipInfo,
        tooltipName,
      } = this.props;
      const showToolboxTip = activeToolboxTip === tooltipName && !isToolboxTipHidden;
      const { tipOutlineRectangle } = tooltipInfo[tooltipName];

      if (!showToolboxTip || !tipOutlineRectangle) {
        return null;
      }

      const top = tipOutlineRectangle.top - BUILDER_TOP_PADDING - this.props.topOffset;
      const left = tipOutlineRectangle.right + this.props.leftOffset + TOOLTIP_ARROW_OFFSET;
      return (
        <Popover
          className={this.props.className}
          positionLeft={left}
          positionTop={top}
          id={this.props.id}
          placement={this.props.tooltipPlacement}
        >
          <button
            className="close-tip"
            onClick={() => this.props.hideCurrentToolboxTip(tooltipName)}
          >
            <img
              alt="Close Tip"
              src="/images/self-serve-builder/close-tooltip-icon-2x.png"
            />
          </button>
          <WrappedComponent
            hideAllToolboxTips={this.props.hideAllToolboxTips}
            isToolboxTourHidden={this.props.isToolboxTourHidden}
            {...this.props}
          />
        </Popover>
      );
    }
  }

  WrappedComponentWithToolboxTourTooltip.defaultProps = {
    activeToolboxTip: null,
    className: '',
    leftOffset: 0,
    tooltipPlacement: 'right',
    topOffset: 0,
  };

  WrappedComponentWithToolboxTourTooltip.propTypes = {
    activeToolboxTip: PropTypes.string,
    className: PropTypes.string,
    hideAllToolboxTips: PropTypes.func.isRequired,
    hideCurrentToolboxTip: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    isToolboxTipHidden: PropTypes.bool.isRequired,
    isToolboxTourHidden: PropTypes.bool.isRequired,
    leftOffset: PropTypes.number,
    tooltipInfo: CustomPropTypes.hashmapOf(
      PropTypes.shape({
        tipOutlineRectangle: PropTypes.shape({
          bottom: PropTypes.number,
          height: PropTypes.number,
          left: PropTypes.number,
          right: PropTypes.number,
          top: PropTypes.number,
          width: PropTypes.number,
          x: PropTypes.number,
          y: PropTypes.number,
        }),
        isSeen: PropTypes.bool,
      }).isRequired,
    ).isRequired,
    tooltipName: PropTypes.string.isRequired,
    tooltipPlacement: PropTypes.string,
    topOffset: PropTypes.number,
  };

  const mapStateToProps = ({ ToolboxTooltipTourReducer }) => (
    {
      activeToolboxTip: ToolboxTooltipTourReducer.activeToolboxTip,
      isToolboxTipHidden: ToolboxTooltipTourReducer.isToolboxTipHidden,
      isToolboxTourHidden: ToolboxTooltipTourReducer.isToolboxTourHidden,
      tooltipInfo: ToolboxTooltipTourReducer.tooltipInfo,
    }
  );

  const mapDispatchToProps = dispatch => (
    bindActionCreators({
      showNextTip: TooltipTourActions.showNextTip,
      hideAllToolboxTips: TooltipTourActions.hideAllToolboxTips,
      hideCurrentToolboxTip: TooltipTourActions.hideCurrentToolboxTip,
    }, dispatch)
  );

  const ToolboxTourTooltipWithRedux = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WrappedComponentWithToolboxTourTooltip);
  return ToolboxTourTooltipWithRedux;
};
export default withToolboxTourTooltip;



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/withToolboxTourTooltip.jsx